/**
 * Types for drive-related data structures
 */

/**
 * Drive type enumeration
 */
export enum DriveType {
  MANEUVER = "maneuver",
  JUMP = "jump",
  REACTION = "reaction",
}

/**
 * Interface for drive specifications
 */
export interface DriveSpec {
  type: DriveType;
  name: string;
  baseTons: number;
  baseCost: number;
  basePower: number;
  baseMaintenance: number;
  techLevel: number;
  minRating: number;
  maxRating: number;
  description: string;
}

/**
 * Interface for drive potential
 */
export interface DrivePotential {
  type: DriveType;
  rating: number;
  percentOfHull: number;
  techLevel: number;
  description: string;
}

/**
 * Interface for drive statistics (calculated values)
 */
export interface DriveStats {
  tons: number;
  cost: number;
  power: number;
  maintenanceCost: number;
}

/**
 * Interface for a drive (minimal state storage)
 * Only stores essential data, calculated values are computed on-the-fly
 */
export interface Drive {
  type: DriveType;
  rating: number;
  techLevel: number;
  description: string;
  section?: number; // For breakaway sections
  isPrimary?: boolean; // For multiple drives of same type (primary/additional)
  id?: string; // Unique identifier for multiple drives of same type
  role?: 'primary' | 'additional'; // Role of this drive
}

/**
 * Interface for a drive with calculated values (for display/use)
 * This extends Drive with computed fields
 */
export interface DriveWithCalculations extends Drive {
  tons: number;
  cost: number;
  weight: number;
  power: number;
  maintenanceCost: number;
}

export interface DriveSelection extends Drive {
  // No additional properties needed as they're all in Drive
}
